<div class="content-blk">
  <div class="container cart-page">
    <!--<h5 class="page-title">
      Shopping Cart
    </h5>-->
    <!-- Cart Items header-->
    <mat-card class="spg-mat-card mat-card-cmn" *ngIf="cartItems?.length == 0">
      <mat-card-header>
        <mat-card-title>MY CART (0)</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="text-center">
          <img src="assets/img/emptycart.PNG">
          <span> Your cart is empty</span>
          <a *ngIf="userRole==='EndUser'" [routerLink]="['/',parentRouteParam]"> Continue Shopping</a>
          <a *ngIf="userRole==='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'" [routerLink]="[ '/store/customizedproducts']"> Continue Shopping more order sample</a>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-horizontal-stepper [linear]="true" #stepper [selectedIndex]="selectedIndex"
                            (selectionChange)="selectionChange($event)" class="shpg-blk"
                            *ngIf="cartItems?.length > 0">
      <!-- cart items -->
      <mat-step class="end-user-cart">
        <ng-template matStepLabel>Shopping Cart</ng-template>
        <div class="main-cart">
          <div class="row">
            <div class="col-md-8">
              <!-- items mat card -->
              <mat-card class="spg-mat-card mat-card-cmn">
                <mat-card-header>
                  <mat-card-title>MY CART ({{cartItems?.length}})</mat-card-title>
                </mat-card-header>
                <input type="hidden">
                <mat-card-content *ngFor="let item of cartItems">
                  <app-cart-item [item]="item" (fn_MoveToWishList)="fn_MoveToWishList($event)"
                                 (fn_RemoveCartitem)="fn_RemoveCartitem($event)"
                                 (fn_UpdateQty)="fn_UpdateQty($event.id,$event.order)"></app-cart-item>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-md-4">
              <!-- total no of item pricing -->
              <mat-card class="mat-card-cmn crt-tl">
                <mat-card-header>
                  <mat-card-title>Cart Summary</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row spg-pr-tm">
                    <div class="col-sm-8">
                      <strong>
                        Price ({{cartItems?.length}}
                        <span *ngIf="cartItems?.length > 1">
                          items
                        </span>
                        <span *ngIf="cartItems?.length == 1">
                          item
                        </span>)
                      </strong>
                    </div>
                    <div class="col-sm-4  text-right">
                      {{cartTotal | currency:'USD':'symbol':'1.2-2'}}
                    </div>
                  </div>
                  <div class="shpg-dvd">
                    <div  *ngIf="diliverCostShow" class="row">
                      <div class="col-sm-8">
                        <strong>Shipping charges (if any)</strong>
                      </div>
                      <div class="col-sm-4  text-right">
                        {{deliveryCost | currency:'USD':'symbol':'1.2-4'}}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-8">
                        <strong>Total amount</strong>
                      </div>
                      <div class="col-sm-4  text-right">
                        <span class="shp-ttl">
                          {{(diliverCostShow ? (cartTotal + deliveryCost )  : (cartTotal) )| currency:'USD':'symbol':'1.2-2'}}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <button class="mat-btn btn-block btn-danger" mat-button (click)="goto(1)">Continue</button>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-step>

      <!-- Address -->
      <mat-step>
        <ng-template matStepLabel>Address</ng-template>
        <app-address-list [loginUserId]="loginUserId" (FetchAddress)="getAddress($event)"></app-address-list>
        <div class="row cart-tp-bk">
          <div class="col-sm-6">
            <button mat-button (click)="goto(0)" class="mat-btn mat-back">Back</button>
          </div>
          <div class="col-sm-6 text-right">
            <button mat-button class="mat-btn btn-danger" (click)="goto(2)">Proceed to Payment</button>
          </div>
        </div>
      </mat-step>

      <!-- Payment & checkout -->
      <mat-step>
        <ng-template matStepLabel>Payment</ng-template>
        <div class="prcd-crd-wp">
          <div class="row">
            <div class="col-md-5">
              <mat-card class="mat-card-cmn crt-tl">
                <mat-card-header>
                  <mat-card-title> Card Payment</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">

                    <form id="cardForm">
                      <div class="panel">
                        <div class="panel__content">
                          <div class="textfield--float-label alignment">
                            <!-- Begin hosted fields section -->
                            <label class="hosted-field--label">
                              Cardholder Name <span style="color:red">*</span>
                            </label>
                            <div id="cc-name" class="hosted-field"></div>
                            <!-- End hosted fields section -->
                          </div>
                          <div class="textfield--float-label alignment card-number">
                            <!-- Begin hosted fields section -->
                            <label class="hosted-field--label">
                              <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" /></svg>
                              </span> Card Number <span style="color:red">*</span>
                            </label>
                            <div id="card-number" class="hosted-field"></div>
                            <div id="card-image"></div>
                            <!-- End hosted fields section -->
                          </div>
                          <div class="row alignment">
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <!-- Begin hosted fields section -->
                                <label class="hosted-field--label">
                                  <span class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" /></svg>
                                  </span>
                                  Expiration Date <span style="color:red">*</span>
                                </label>
                                <div id="expiration-date" class="hosted-field"></div>
                                <!-- End hosted fields section -->
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <!-- Begin hosted fields section -->
                                <label class="hosted-field--label">
                                  <span class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" /></svg>
                                  </span>
                                  CVV <span style="color:red">*</span>
                                </label>
                                <div id="cvv" class="hosted-field"></div>
                                <!-- End hosted fields section -->
                              </div>
                            </div>
                          </div>
                          <div class="row alignment">
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <!-- Begin hosted fields section -->
                                <label class="hosted-field--label">
                                  Postal Code <span style="color:red">*</span>
                                </label>
                                <div id="cc-postal-code" class="hosted-field"></div>
                                <!-- End hosted fields section -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <footer style="text-align:center;" class="panel__footer">
                          <input type="button" value="Pay Now" (click)="tokenizeUserDetails();" class="pay-button" [disabled]="!isCreditCardFormLoad" />
                        </footer>
                        <br />
                      </div>

                    </form>

                  </div>
                </mat-card-content>

              </mat-card>

              <div style="text-align:center" class="paypal-payment">
                <h5><strong>Or</strong></h5>
              </div>
              <div>                
                <ngx-paypal [config]="payPalConfig"></ngx-paypal>
              </div>

            </div>
            <div class="col-md-2">
            </div>
            <!-- Cart summary -->
            <div class="col-md-5">
              <mat-card class="mat-card-cmn crt-tl">
                <mat-card-header>
                  <mat-card-title>Cart Summary</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-6">
                          <strong>Shipping Address:</strong>
                        </div>
                        <div class="col-sm-6" style="text-align:right;" *ngIf="selectedAddress">
                          <h6>{{selectedAddress.Name}}</h6>
                          <div>
                            {{selectedAddress.AddressLine}}, <br />
                            {{selectedAddress.Country}}, {{selectedAddress.State}}, <br />
                            {{selectedAddress.ZipCode}}
                          </div>

                        </div>
                      </div>
                      <hr />
                      
                      <div class="row spg-pr-tm">
                        <div class="col-sm-8">
                          <strong>
                            Price ({{cartItems?.length}}
                            <span *ngIf="cartItems?.length > 1">
                              items
                            </span>
                            <span *ngIf="cartItems?.length == 1">
                              item
                            </span>)
                          </strong>
                        </div>
                        <div class="col-sm-4  text-right">
                          {{cartTotal |  currency:'USD':'symbol':'1.2-2'}}
                        </div>
                      </div>

                      <div class="shpg-dvd">
                        <div  *ngIf="diliverCostShow" class="row">
                          <div class="col-sm-8">
                            <strong>Shipping charges (if any)</strong>
                          </div>
                          <div class="col-sm-4  text-right">
                            <div>
                              {{deliveryCost | currency:'USD':'symbol':'1.2-2'}}
                            </div>                            
                            <small *ngIf="thirdPartyShipping && (userRole === 'StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember')">
                              Opt-in Third Party Shipping 
                            </small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-8">
                            <strong>Total amount</strong>
                          </div>
                          <div class="col-sm-4  text-right">
                            <span class="shp-ttl">
                              {{cartTotal + deliveryCost | currency:'USD':'symbol':'1.2-2'}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

          </div>
        </div>
        <!-- Final Stepper back button -->
        <div class="row cart-tp-bk">
          <div class="col-sm-6">
            <button mat-button (click)="goto(1)" class="mat-btn mat-back btn-success">Back</button>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

